export default "__VITE_ASSET__CBrkILcq__"